import { SmartTableColumn } from '@design/components/smart-table';
import { WithNAFallback } from '@design/components/table';
import { SharedTable } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/shared-table/SharedTable';
import { useTranslation } from 'react-i18next';

import styles from './KpisTable.module.scss';

export interface KpiData {
  title: string;
  description: string;
  value: string;
}

export interface KpisTableProps {
  kpisData: KpiData[];
}

export const KpisTable = ({ kpisData }: KpisTableProps) => {
  const { t } = useTranslation(['earnings']);

  const tableData = (kpisData || []).map((item, index) => ({
    ...item,
    key: `kpi-${index}`,
  }));

  const tableColumns: SmartTableColumn<KpiData>[] = [
    {
      key: 'title',
      label: t('earningsInsight.drawer.earningsPreview.tables.kpi'),
      render: (value: string) =>
        value ? <div className={styles.titleCell}>{value}</div> : '',
    },
    {
      key: 'description',
      label: t('earningsInsight.drawer.earningsPreview.tables.significance'),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<div className={styles.descriptionCell}>{value}</div>}
        />
      ),
    },
    {
      key: 'value',
      label: t(
        'earningsInsight.drawer.earningsPreview.tables.consensusExpectations'
      ),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<div className={styles.numberCell}>{value}</div>}
        />
      ),
    },
  ];

  return (
    <>
      <h2 className={styles.title}>
        {t('earnings:earningsInsight.drawer.earningsPreview.items.kpis')}
      </h2>
      <SharedTable
        tableData={tableData}
        tableColumns={tableColumns}
        noCellPadding
      />
    </>
  );
};
